var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDryRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50007 8.08492L2.76507 6.34992C2.67158 6.25643 2.54479 6.20391 2.41257 6.20391C2.28036 6.20391 2.15356 6.25643 2.06007 6.34992C1.96658 6.44341 1.91406 6.5702 1.91406 6.70242C1.91406 6.76788 1.92696 6.83271 1.95201 6.89319C1.97706 6.95367 2.01378 7.00863 2.06007 7.05492L4.15007 9.14492C4.34507 9.33992 4.66007 9.33992 4.85507 9.14492L10.1451 3.85492C10.2386 3.76143 10.2911 3.63463 10.2911 3.50242C10.2911 3.3702 10.2386 3.24341 10.1451 3.14992C10.0516 3.05643 9.92479 3.00391 9.79257 3.00391C9.66036 3.00391 9.53356 3.05643 9.44007 3.14992L4.50007 8.08492Z",
    fill: "#4A4E69"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDryRun);
export default __webpack_public_path__ + "static/media/DryRun.72493fb86ec54eb00b2b5e185ed7a6eb.svg";
export { ForwardRef as ReactComponent };